// @flow
import moment from 'moment';

const getDateAsMoment = (date: string) => {
  if (date?._isAMomentObject) return date;
  return date?.length ? moment(date) : '';
};

export default getDateAsMoment;
